import styled from 'styled-components';
import { Card } from '@acast/decibel';

export default styled(Card)`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;
